import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CorporateServices from "@/pages/CorporateServices";
import VisaServices from "@/pages/VisaServices";
import VisionMission from "@/pages/VisionMission";
import WhyFlyGowell from "@/pages/WhyFlyGowell";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/corporate-services" element={<CorporateServices />} />
            <Route path="/visa-services" element={<VisaServices />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/why-fly-gowell" element={<WhyFlyGowell />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
